<template>
    <div class="all">
        <van-nav-bar
                :title="title"
                left-text="返回"
                right-text
                left-arrow
                @click-left="$goBack()"
                @click-right
        />
        <div class="showContent">
         
        
            <div class="rowOrder" v-if="sortArr&&sortArr.length>0">
                            <van-row class="head">
                                <van-col span="6">任务</van-col>
                                <van-col span="6">任务项</van-col>
                                <van-col span="4">价格</van-col>
                                <van-col span="4" v-if="trader.type!=setTrader.type">设价</van-col>
                                <van-col span="4" v-if="trader.type==setTrader.type">下级价</van-col>
                                <van-col span="4">操作</van-col>

                            </van-row>
                            <van-row v-for="g in sortArr" :key="g.id">
                                <van-col span="6">{{g.jobName}}</van-col>
                                <van-col span="6">{{g.name}}</van-col>
                                <van-col span="3">{{g.extendsPriceRMB}}</van-col>
                                <van-col span="5" v-if="trader.type!=setTrader.type">
                                   <van-field input-align="left" type="number"  v-model="g.priceRMB" placeholder="设价" :disabled="setTrader.type!=1&&!g.canSetPrice"  />
                                </van-col>
                                <van-col span="5" v-if="trader.type==setTrader.type">
                                   <van-field input-align="left" type="number"  v-model="g.lowerPriceRMB" placeholder="下级价"  :disabled="setTrader.type!=1&&g.disLowerPrice"  />
                                </van-col>
                             <van-col span="4">
                                 <van-button round size="small"  @click="submit(g)" style="width:5rem;">提交</van-button>
                                 
                                 </van-col>
                            </van-row>
                        </div>
                        <div class="noData" v-else>
                                <div><i class="icon-task icon-ku"></i></div>
                                <div>暂无数据</div>
                        </div>
                        
           
        </div>

       

    </div>


</template>

<script>
   
import userAPI from '@/api/user'
import { Toast } from 'vant'

    export default {
        data() {
            return {
                traderId:-1,
                jobId:-1,
                sortArr:[],
                setTrader:{},
                trader:{}
              
                
            }
        },
        computed: {
          
        },
        created() {
            if(this.$route.meta){
               this.title =   this.$route.meta.title
            }
            if(this.$route.query.traderId){
                this.traderId=this.$route.query.traderId;
            }
            if(this.$route.query.jobId){
                this.jobId=this.$route.query.jobId;
            }
            console.log('jjjj'+this.traderId+'---'+this.jobId)
            this.initItemPriceList();

        },
    
        methods: {
            //加载价格信息
            initItemPriceList() {
                this.submitLoading = true
            
                var form={};
                form.traderId=this.traderId;
                userAPI.jobItemPriceList(form).then((result) => {
                    console.log('my group----');
                    console.log(result);
                   
                
                    this.setTrader=result.data.setTrader;
                    this.trader=result.data.trader;
                    this.sortArr=result.data.list;
                     
                     if(this.jobId>0){
                         this.sortArr=this.sortArr.filter(item=>item.jobId == this.jobId)
                     }
                     

                    this.submitLoading = false
                   
                }).catch(()=>{
                  this.submitLoading = false
                })
            },
              submit(row) {
                  //console.log(row);
                 // return;
                row.traderId = this.trader.id
                userAPI.jobItemPriceSave(row).then((res) => {

                     Toast('设价'+res.mng)
                    this.initItemPriceList()
                }).catch(() => {
                    this.initItemPriceList()
                })
            },
      
    
         
        }
    }
</script>

<style lang="scss" scoped>
    .all {
        background-color: #fff;
    }
 .head{
                color:#000;
    box-shadow: 0 0 10px #e5e5e5;
               
              }

.noData{
      width: 11rem;
      height: 11rem;
      margin: 4rem auto 4rem auto;
      text-align: center;
      color: #E6E6E6;
      i{
        font-size: 5rem;
      }
    }

.van-field__control{
    width:4rem;
}
    .showContent {
        margin-top: 1rem;
        font-size: 1.1rem;
        .van-row {
            margin: 0.5rem 1rem 0rem 1rem;
            line-height: 3.5rem;
            img {
                height: 1.5rem;
                width: 2rem;
            }
            border-style: none;
            border-bottom-style: solid;
            border-bottom-width: thin;
            border-bottom-color: #f2f2f2;
            .van-button {
                   background-color: #ee9900;
             
              color: #fff;
            }
        }

    }



</style>
